import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const EstablishmentContext = createContext(null);

export function EstablishmentProvider({ children }) {
  const { user } = useAuth();
  const [establishments, setEstablishments] = useState([]);
  const [currentId, setCurrentId] = useState(() => localStorage.getItem("respondia_est") || null);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/establishments");
      setEstablishments(data);
      setCurrentId((prev) => {
        if (prev && data.some((e) => e.id === prev)) return prev;
        return data[0]?.id || null;
      });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (user && user.id) reload();
  }, [user, reload]);
  useEffect(() => { const h = () => reload(); window.addEventListener("establishments-changed", h); return () => window.removeEventListener("establishments-changed", h); }, [reload]);

  const setCurrent = (id) => {
    setCurrentId(id);
    localStorage.setItem("respondia_est", id);
  };

  const current = establishments.find((e) => e.id === currentId) || null;

  return (
    <EstablishmentContext.Provider value={{ establishments, current, currentId, setCurrent, reload, loading }}>
      {children}
    </EstablishmentContext.Provider>
  );
}

export function useEstablishments() {
  return useContext(EstablishmentContext);
}
